import type {ReactElement, ReactNode} from 'react';

import type {UserDetailsReturnProps} from '@/screens/User/Details/types';

import NoteTable from './NoteTable';

type UserSecurityNotesProps = Pick<
  UserDetailsReturnProps,
  | 'isLoadingSecurityNotes'
  | 'securityNotes'
  | 'hasMoreNotes'
  | 'loadMoreSecurityNotes'
  | 'isFetchingMore'
  | 'dataCy'
>;
const UserSecurityNotes = ({
  securityNotes,
  isLoadingSecurityNotes,
  hasMoreNotes,
  loadMoreSecurityNotes,
  isFetchingMore,
  dataCy,
}: UserSecurityNotesProps): ReactElement => {
  let content: ReactNode;
  if (isLoadingSecurityNotes) {
    content = <p className="text-sm">Loading...</p>;
  } else if (!securityNotes.length) {
    content = (
      <div className="text-sm text-gray-500 dark:text-gray-300">
        No security notes
      </div>
    );
  } else {
    content = (
      <NoteTable
        dataCy={dataCy}
        securityNotes={securityNotes}
        hasMoreNotes={hasMoreNotes}
        loadMoreSecurityNotes={loadMoreSecurityNotes}
        isFetchingMore={isFetchingMore}
      />
    );
  }

  return (
    <div className="flex flex-col gap-3">
      <div className="text-sm text-slate-500 w-full dark:text-slate-100">
        {content}
      </div>
    </div>
  );
};

export default UserSecurityNotes;
